<template>
  <div style="padding: 0 20px; background: #fff">
    <a-tabs :activeKey="activeKey" destroyInactiveTabPane @change="changeTab">
      <a-tab-pane v-for="(item, index) in tabList" :key="item.key" :tab="item.tab">
        <SchemeCard
          ref="schemeCardRef"
          :key="item.key"
          :activeKey="activeKey"
          :actionUrl="currTabObj.url"
          :cardType="item.cardType"
          :keysFormArr="currTabObj.keysFormArr"
          @cardClick="schemeCardClick"
        />
      </a-tab-pane>
      <a-button type="primary" slot="tabBarExtraContent" @click="createLeague">创建</a-button>
    </a-tabs>
  </div>
</template>
<script>
import SchemeCard from '@/comUi/SchemeCard/components/SchemeCard.vue'
import { getDictCodeData } from '@/utils/util'

const keysFormArr = ['title', 'cover', 'courseDesc', 'file', 'content']
export default {
  name: 'MentalActivity',
  components: {
    SchemeCard,
  },
  data() {
    return {
      activeKey: '5',
      loading: false,
      tabList: [
        {
          tab: '社团活动',
          key: '5',
          url: 'resourceCource',
          cardType: '1',
          keysFormArr: [...keysFormArr],
        },
        {
          tab: '主题讲座',
          key: '6',
          url: 'resourceCource',
          cardType: '1',
          keysFormArr: [...keysFormArr],
        },
        {
          tab: '专题活动',
          key: '7',
          url: 'resourceCource',
          cardType: '1',
          keysFormArr: [...keysFormArr],
        },
      ],
      categoryList: [],
      fitGradeList: [],
      cardList: [],
      cardObj: {},
      queryParam: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },
  created() {
    const backKey = this.$router.history.current.query.activeKey
    if (backKey) {
      this.activeKey = backKey
    }
  },
  computed: {
    currTabObj() {
      return this.tabList.find((item) => item.key === this.activeKey)
    },
  },
  methods: {
    getDictCodeData() {
      // this.fitGradeList = getDictCodeData('course_applicable_grade')
      // this.categoryList = getDictCodeData('course_sort')
      const fitGradeList = getDictCodeData('course_applicable_grade')
      const categoryList = getDictCodeData('course_sort')
      this.tabList.forEach((item, index) => {
        this.$set(this.tabList, index, {
          ...item,
          // fitGradeList: cloneDeep(fitGradeList),
          // categoryList: cloneDeep(categoryList),
        })
      })
    },
    changeTab(key) {
      this.activeKey = key
      this.cardList = []
      // this.getTabList()
    },
    createLeague() {
      // this.$refs.createCourseModalRef.showModal()
      this.$refs.schemeCardRef[0].showCardModal()
    },
    schemeCardClick(data) {
      this.cardObj = data
    },
  },
}
</script>
